import { PROYECT, api_post, api_put, api_get, api_delete } from "services/api";
import { fetchAccountsByStation } from "../accountingAccount/accountingAccountService";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import ACCOUNTING_ACCOUNT_RELATION_TYPES, { ACCOUNTING_ACCOUNT_RELATION_LOADINGS } from "redux/reducers/accountingAccountRelation/accountingAccountRelationTypes";

const {
  CREATE_ACCOUNTING_ACCOUNT_RELATION,
  DELETE_ACCOUNTING_ACCOUNT_RELATION,
  GET_ACCOUNTS_FOR_RELATION,
  GET_ACCOUNTING_ACCOUNT_RELATION_LIST,
  SET_ACCOUNTING_ACCOUNT_RELATION_SEARCH_FILTERS,
  UPDATE_ACCOUNTING_ACCOUNT_RELATION,
} = ACCOUNTING_ACCOUNT_RELATION_TYPES;

const { GET_RELATION_LIST, GET_ACCOUNT_LIST, CREATE, UPDATE, DELETE } = ACCOUNTING_ACCOUNT_RELATION_LOADINGS;
const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/accounting_account_relations`;
const getIdUrl = (accountingAccountRelationId) => `${baseUrl}/${accountingAccountRelationId}`;

// El API sólo usa estos campos; el resto del formulario es de presentación.
const toRelationBody = ({ idCompany, idAccountingAccount, type }) => ({
  idCompany,
  idAccountingAccount,
  type,
});

// El POST/PUT regresa la relación dentro de un arreglo (el getById del back
// sale de un JSON_ARRAYAGG); se acepta también un objeto por si el back lo
// desenvuelve.
const toRelation = (resp) => (Array.isArray(resp) ? resp[0] : resp);

export const setAccountingAccountRelationSearchFilters = (key, value) => ({
  type: SET_ACCOUNTING_ACCOUNT_RELATION_SEARCH_FILTERS,
  payload: { key, value },
});

// Si la planta cambió durante la búsqueda, el reducer descarta la respuesta
// y el aviso de lista vacía ya no aplica.
const isCurrentStation = (getState, stationId) =>
  getState().accountingAccountRelation.station?.id === stationId;

export const getAccountingAccountList = (stationId) => async (dispatch, getState) => {
  dispatch(startRequestComp(GET_ACCOUNT_LIST));
  try {
    const resp = await fetchAccountsByStation(stationId);
    if (!resp.length && isCurrentStation(getState, stationId)) {
      dispatch(setSnackbar("No se encontraron cuentas contables para la planta seleccionada", "warning"));
    }
    dispatch({ type: GET_ACCOUNTS_FOR_RELATION, payload: { stationId, list: resp } });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(GET_ACCOUNT_LIST));
  }
};

export const getAccountingAccountRelationList = (stationId) => async (dispatch, getState) => {
  const url = `${baseUrl}/by-station/${stationId}`;
  dispatch(startRequestComp(GET_RELATION_LIST));
  try {
    let resp = await api_get(url);
    if (!Array.isArray(resp)) resp = [];
    if (!resp.length && isCurrentStation(getState, stationId)) {
      dispatch(setSnackbar("No se encontró relación de cuentas para la planta seleccionada", "warning"));
    }
    dispatch({ type: GET_ACCOUNTING_ACCOUNT_RELATION_LIST, payload: { stationId, list: resp } });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(GET_RELATION_LIST));
  }
};

export const createAccountingAccountRelation = (formValues, action = null) => async (dispatch) => {
  dispatch(startRequestComp(CREATE));
  try {
    const resp = await api_post(baseUrl, toRelationBody(formValues));
    dispatch({
      type: CREATE_ACCOUNTING_ACCOUNT_RELATION,
      // La respuesta no trae idStation; el reducer lo usa para saber si la
      // relación pertenece a la planta cargada.
      payload: { ...toRelation(resp), idStation: formValues.idStation },
    });
    dispatch(setSnackbar("Relación cuenta contable creada con éxito", "success"));
    if (action) action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(CREATE));
  }
};

export const updateAccountingAccountRelation = (
  accountingAccountRelationId, formValues, action = null,
) => async (dispatch) => {
  const url = getIdUrl(accountingAccountRelationId);
  dispatch(startRequestComp(UPDATE));
  try {
    const resp = await api_put(url, toRelationBody(formValues));
    dispatch({ type: UPDATE_ACCOUNTING_ACCOUNT_RELATION, payload: toRelation(resp) });
    dispatch(setSnackbar("Relación cuenta contable actualizada con éxito", "success"));
    if (action) action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(UPDATE));
  }
};

export const deleteAccountingAccountRelation = (accountingAccountRelationId, action = null) => async (dispatch) => {
  const url = getIdUrl(accountingAccountRelationId);
  dispatch(startRequestComp(DELETE));
  try {
    await api_delete(url);
    dispatch({ type: DELETE_ACCOUNTING_ACCOUNT_RELATION, payload: accountingAccountRelationId });
    dispatch(setSnackbar("Relación cuenta contable eliminada con éxito", "success"));
    if (action) action();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(DELETE));
  }
};
